// 城市 / 国家的英文名，只用于**搜索**：海外用户常按当地英文地名输入（Tokyo、Vancouver），
// 原来只能按中文名搜到。存库与配单仍用中文名（与移动端清单逐条一致，见 tests/city-list-sync.test.js）。
// 值里 `|` 之后是只用于搜索的别名（NYC、Saigon），显示只取第一段。
// 同名城市按 `名称|国家代码` 区分（美国 Oakland / 新西兰 Auckland 都叫「奥克兰」）。

const CITY_EN = {
  北京: 'Beijing', 上海: 'Shanghai', 广州: 'Guangzhou', 深圳: 'Shenzhen', 杭州: 'Hangzhou',
  南京: 'Nanjing', 武汉: 'Wuhan', 成都: 'Chengdu', 西安: "Xi'an|Xian", 重庆: 'Chongqing',
  天津: 'Tianjin', 苏州: 'Suzhou', 长沙: 'Changsha', 青岛: 'Qingdao', 大连: 'Dalian',
  厦门: 'Xiamen', 宁波: 'Ningbo', 福州: 'Fuzhou', 济南: 'Jinan', 哈尔滨: 'Harbin',
  沈阳: 'Shenyang', 长春: 'Changchun', 石家庄: 'Shijiazhuang', 太原: 'Taiyuan', 呼和浩特: 'Hohhot',
  兰州: 'Lanzhou', 西宁: 'Xining', 银川: 'Yinchuan', 乌鲁木齐: 'Urumqi', 拉萨: 'Lhasa',
  台北: 'Taipei', 香港: 'Hong Kong', 澳门: 'Macau|Macao',
  郑州: 'Zhengzhou', 合肥: 'Hefei', 昆明: 'Kunming', 南宁: 'Nanning', 贵阳: 'Guiyang',
  南昌: 'Nanchang', 海口: 'Haikou', 三亚: 'Sanya', 无锡: 'Wuxi', 温州: 'Wenzhou',
  珠海: 'Zhuhai', 东莞: 'Dongguan', 佛山: 'Foshan', 高雄: 'Kaohsiung', 台中: 'Taichung',
  东京: 'Tokyo', 大阪: 'Osaka', 京都: 'Kyoto', 名古屋: 'Nagoya', 福冈: 'Fukuoka',
  札幌: 'Sapporo', 横滨: 'Yokohama', 神户: 'Kobe', 广岛: 'Hiroshima', 仙台: 'Sendai', 那霸: 'Naha|Okinawa',
  首尔: 'Seoul', 釜山: 'Busan', 大邱: 'Daegu', 仁川: 'Incheon', 光州: 'Gwangju',
  大田: 'Daejeon', 蔚山: 'Ulsan', 济州: 'Jeju',
  纽约: 'New York|NYC', 洛杉矶: 'Los Angeles|LA', 芝加哥: 'Chicago', 休斯顿: 'Houston', 费城: 'Philadelphia',
  凤凰城: 'Phoenix', 圣安东尼奥: 'San Antonio', 圣地亚哥: 'San Diego', 达拉斯: 'Dallas', 圣何塞: 'San Jose',
  奥斯汀: 'Austin', 杰克逊维尔: 'Jacksonville', 旧金山: 'San Francisco|SF', 哥伦布: 'Columbus', 夏洛特: 'Charlotte',
  底特律: 'Detroit', 埃尔帕索: 'El Paso', 西雅图: 'Seattle', 丹佛: 'Denver', 华盛顿: 'Washington DC',
  波士顿: 'Boston', 纳什维尔: 'Nashville', 巴尔的摩: 'Baltimore', 俄克拉荷马城: 'Oklahoma City', 波特兰: 'Portland',
  拉斯维加斯: 'Las Vegas', 路易斯维尔: 'Louisville', 密尔沃基: 'Milwaukee', 阿尔伯克基: 'Albuquerque', 图森: 'Tucson',
  弗雷斯诺: 'Fresno', 萨克拉门托: 'Sacramento', 长滩: 'Long Beach', 堪萨斯城: 'Kansas City', 梅萨: 'Mesa',
  亚特兰大: 'Atlanta', 奥马哈: 'Omaha', 科罗拉多斯普林斯: 'Colorado Springs', 罗利: 'Raleigh', 迈阿密: 'Miami',
  弗吉尼亚海滩: 'Virginia Beach', '奥克兰|US': 'Oakland', 明尼阿波利斯: 'Minneapolis', 塔尔萨: 'Tulsa', 阿灵顿: 'Arlington',
  坦帕: 'Tampa', 新奥尔良: 'New Orleans', 克利夫兰: 'Cleveland', 威奇托: 'Wichita',
  尔湾: 'Irvine', 匹兹堡: 'Pittsburgh', 盐湖城: 'Salt Lake City', 檀香山: 'Honolulu|Hawaii', 圣路易斯: 'St. Louis|Saint Louis',
  伦敦: 'London', 曼彻斯特: 'Manchester', 伯明翰: 'Birmingham', 爱丁堡: 'Edinburgh', 利物浦: 'Liverpool',
  格拉斯哥: 'Glasgow', 诺丁汉: 'Nottingham', 谢菲尔德: 'Sheffield', 利兹: 'Leeds', 剑桥: 'Cambridge', 牛津: 'Oxford',
  巴黎: 'Paris', 柏林: 'Berlin', 法兰克福: 'Frankfurt', 慕尼黑: 'Munich|Muenchen', 汉堡: 'Hamburg',
  罗马: 'Rome|Roma', 米兰: 'Milan|Milano', 马德里: 'Madrid', 巴塞罗那: 'Barcelona', 阿姆斯特丹: 'Amsterdam',
  布鲁塞尔: 'Brussels', 维也纳: 'Vienna|Wien', 苏黎世: 'Zurich', 斯德哥尔摩: 'Stockholm', 哥本哈根: 'Copenhagen',
  奥斯陆: 'Oslo', 赫尔辛基: 'Helsinki', 华沙: 'Warsaw', 布拉格: 'Prague', 布达佩斯: 'Budapest',
  里斯本: 'Lisbon', 雅典: 'Athens', 都柏林: 'Dublin', 莫斯科: 'Moscow',
  新加坡: 'Singapore', 曼谷: 'Bangkok', 吉隆坡: 'Kuala Lumpur|KL', 雅加达: 'Jakarta', 马尼拉: 'Manila',
  胡志明市: 'Ho Chi Minh City|Saigon', 河内: 'Hanoi', 金边: 'Phnom Penh', 万象: 'Vientiane', 仰光: 'Yangon',
  达卡: 'Dhaka', 科伦坡: 'Colombo', 加德满都: 'Kathmandu', 廷布: 'Thimphu', 马累: 'Male',
  迪拜: 'Dubai',
  悉尼: 'Sydney', 墨尔本: 'Melbourne', 布里斯班: 'Brisbane', 珀斯: 'Perth', 阿德莱德: 'Adelaide',
  堪培拉: 'Canberra', 黄金海岸: 'Gold Coast',
  '奥克兰|NZ': 'Auckland', 惠灵顿: 'Wellington', 克赖斯特彻奇: 'Christchurch',
  多伦多: 'Toronto', 温哥华: 'Vancouver', 蒙特利尔: 'Montreal', 卡尔加里: 'Calgary', 渥太华: 'Ottawa',
  埃德蒙顿: 'Edmonton', 温尼伯: 'Winnipeg', 魁北克市: 'Quebec City', 汉密尔顿: 'Hamilton', 基奇纳: 'Kitchener',
  维多利亚: 'Victoria',
};

const COUNTRY_EN = {
  CN: 'China', TW: 'Taiwan', HK: 'Hong Kong', MO: 'Macau', JP: 'Japan', KR: 'Korea',
  US: 'USA United States America', GB: 'UK United Kingdom Britain England', FR: 'France', DE: 'Germany',
  IT: 'Italy', ES: 'Spain', NL: 'Netherlands Holland', BE: 'Belgium', AT: 'Austria', CH: 'Switzerland',
  SE: 'Sweden', DK: 'Denmark', NO: 'Norway', FI: 'Finland', PL: 'Poland', CZ: 'Czech', HU: 'Hungary',
  PT: 'Portugal', GR: 'Greece', IE: 'Ireland', RU: 'Russia', SG: 'Singapore', TH: 'Thailand',
  MY: 'Malaysia', ID: 'Indonesia', PH: 'Philippines', VN: 'Vietnam', KH: 'Cambodia', LA: 'Laos',
  MM: 'Myanmar', BD: 'Bangladesh', LK: 'Sri Lanka', NP: 'Nepal', BT: 'Bhutan', MV: 'Maldives',
  AE: 'UAE United Arab Emirates', AU: 'Australia', NZ: 'New Zealand', CA: 'Canada',
};

const aliases = (city) => CITY_EN[`${city.name}|${city.code}`] || CITY_EN[city.name] || '';

/** 城市的英文显示名（无则空串） */
export function cityEnglish(city) {
  return aliases(city).split('|')[0];
}

// 忽略大小写、空格与标点，便于 "new york" / "NewYork" / "st louis" 都能命中
// 含中文（非 ASCII）的搜索词走中文匹配
const hasCjk = (s) => /[^ -~]/.test(s);
const norm = (s) => String(s || '').toLowerCase().replace(/[\s.'’-]/g, '');

/**
 * 城市 {name, country, code} 是否匹配搜索词。
 * 中文按包含匹配（「京」→ 北京、东京）；英文按词首匹配，免得 "uk" 命中 Fukuoka、"la" 命中 Dallas。
 */
export function cityMatches(city, term) {
  const t = norm(term);
  if (!t) return true;
  if (hasCjk(t)) return norm(city.name).includes(t) || norm(city.country).includes(t);
  const phrases = [...aliases(city).split('|'), String(COUNTRY_EN[city.code] || '')];
  // 整个短语（"new york" → newyork）或其中任一单词（"united states" 里的 states）以搜索词开头
  const words = phrases.flatMap((p) => [p, ...p.split(' ')]);
  return words.some((w) => norm(w).startsWith(t));
}

/**
 * 列表筛选用：输入的是清单城市的英文名（Tokyo / new york / NYC）时换成中文名再查，
 * 否则原样返回（库里存的是中文名，后端按中文模糊匹配）。同名城市英文不同，各自换回「奥克兰」。
 */
export function toSearchCity(input, cities) {
  const t = norm(input);
  if (!t || hasCjk(t)) return input;
  const hit = cities.find((c) => aliases(c).split('|').some((a) => norm(a) === t));
  return hit ? hit.name : input;
}
